// extracted by mini-css-extract-plugin
export default {"link":"Login_link__CDQhA","link2":"Login_link2__6kxB9"};